
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ExternalLink, BarChart2, FileText, Clock } from "lucide-react";

const ValocapSection = () => {
  return (
    <section className="py-16 bg-fabre-lightgray">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          <div className="lg:w-1/2 mb-10 lg:mb-0">
            <h2 className="text-3xl font-heading font-bold mb-2 text-fabre-gray">VALOCAP</h2>
            <div className="w-20 h-1 bg-fabre-green mb-6"></div>
            <p className="mb-8 text-lg">
              Votre plateforme digitale qui vous donne un accès complet à vos données et optimise votre gestion des déchets.
            </p>
            
            <div className="space-y-6 mb-8">
              <div className="flex items-start">
                <div className="mr-4 p-2 bg-fabre-lightgreen rounded-full">
                  <BarChart2 className="h-6 w-6 text-fabre-green" />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg mb-1">Suivi en temps réel</h3>
                  <p className="text-gray-600">Visualisez vos données de collecte et valorisation à tout moment</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="mr-4 p-2 bg-fabre-lightgreen rounded-full">
                  <FileText className="h-6 w-6 text-fabre-green" />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg mb-1">Rapports personnalisés</h3>
                  <p className="text-gray-600">Générez des rapports détaillés adaptés à vos besoins</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className="mr-4 p-2 bg-fabre-lightgreen rounded-full">
                  <Clock className="h-6 w-6 text-fabre-green" />
                </div>
                <div>
                  <h3 className="font-heading font-bold text-lg mb-1">Historique complet</h3>
                  <p className="text-gray-600">Accédez à l'historique de vos données sur plusieurs années</p>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild className="bg-fabre-green hover:bg-fabre-darkgreen">
                <Link to="/valocap">En savoir plus</Link>
              </Button>
              <Button 
                variant="outline" 
                className="border-fabre-green text-fabre-green hover:bg-fabre-lightgreen"
                onClick={() => window.open('https://www.valocap.fr/', '_blank')}
              >
                Accéder à Valocap
                <ExternalLink className="ml-2 h-4 w-4" />
              </Button>
            </div>
          </div>
          <div className="lg:w-1/2">
            <img
              src="/lovable-uploads/3f73765a-c2b3-4a12-a805-3b512f7b174d.png"
              alt="Interface Valocap - Plateforme de gestion des déchets"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ValocapSection;
